"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function ModeToggle({
	dark = false,
	className = "",
}: {
	dark?: boolean;
	className?: string;
}) {
	const { setTheme, theme } = useTheme();

	return (
		<Button
			size="icon"
			variant="outline"
			className={cn(dark ? "dark text-white" : "", className)}
			aria-label="Alternar tema"
			onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
		>
			<Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
			<Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
		</Button>
	);
}
